import { render, staticRenderFns } from "./questionAnswerP2h.vue?vue&type=template&id=29ac2571&scoped=true"
import script from "./questionAnswerP2h.vue?vue&type=script&lang=js"
export * from "./questionAnswerP2h.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerP2h.vue?vue&type=style&index=0&id=29ac2571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac2571",
  null
  
)

export default component.exports